export default {
  'header.product': 'Product', 'header.customers': 'Customers', 'header.advertise': 'Advertise', 'header.pricing': 'Pricing',
  'header.signIn': 'Sign in', 'header.startFree': 'Start free', 'header.toggleMenu': 'Toggle menu', 'header.language': 'Change language',
  'header.solutions': 'Solutions', 'header.solutionsText': 'Playbooks by industry and role',
  'header.features': 'Features', 'header.featuresText': 'Points, rewards, tiers and more',
  'header.customersText': 'Teams growing with loyalty',
  'header.security': 'Security', 'header.securityText': 'How member data is protected',
};
